/**
 * Standard rounding: rounds to the nearest integer.
 * Values with a fractional part < 0.5 round down; >= 0.5 round up.
 *
 * Examples:
 *   roundNearest(19.048) → 19
 *   roundNearest(49.524) → 50
 */
export const roundNearest = (value: number): number => Math.round(value);

/**
 * Round to a given number of decimal places using standard rounding.
 *
 * Examples:
 *   roundTo(19.0476, 2) → 19.05
 *   roundTo(49.524, 1) → 49.5
 */
export const roundTo = (value: number, decimals: number): number => {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
};
